export interface BackgroundCheckRequest {
  id: string | null
}

export interface PersonHistoryCrudBeResponse {
  message: string
  status: number
  info: PersonHistoryResponse
}

export interface BackgroundCheckPdfRequest {
  id: string
}

export type PersonHistoryResponse = SocialHistoryItem[]

export interface ISocialCheckInput {
  name: string
  nickname: string
  city?: string
  state: string
  country: string
  email: string
  highSchool: string
  college: string
  phone: string
  twitterUrl: string
  facebookUrl: string
  instagramUrl: string
  linkedInUrl: string
  tikTokUrl: string
  ageOrDateOfBirth: string
}
export enum ESocialCheckStatus {
  None = 'None',
  InQueue = 'InQueue',
  InProgress = 'InProgress',
  Complete = 'Complete',
  Error = 'Error',
  PendingDownloadPdf = 'PendingDownloadPdf',
}

export interface SocialHistoryItem {
  inputs: ISocialCheckInput
  id: string
  pdf: string
  pdfViewed: boolean
  reportDate: string
  status: ESocialCheckStatus
}

export interface ReDownloadPdfResponse {
  info: {
    url: string
  }
}

export interface summary {
  executiveAim: string
  executiveSummary: string
  personalEngagement: string
  personalSentiment: string
  strategyDiversity: string
  strategyThemes: string
  strategyResponse: string
  digitalBehavior: string
  digitalInfluence: string
  recommendationsInsights: string
  recommendationsImprovements: string
  recommentationsConclusion: string
  riskIndicators: string
  sentimentAnalysis: string
  redFlags: string
  webNewsFindings: string
}

export interface Source {
  [key: string]: boolean | undefined
}

export interface Inputs {
  middleName: string
  lastName: string
  ageOrDateOfBirth: string
  city: string
  college: string
  company: string
  countryLong: string
  countryShort: string
  stateLong: string
  stateShort: string
  cityLong: string
  cityShort: string
  country: string
  email: string
  facebookUrl: string
  highSchool: string
  instagramUrl: string
  linkedInUrl: string
  name: string
  nickname: string
  phone: string
  state: string
  tikTokUrl: string
  twitterUrl: string
  topics: string[]
}

export interface Risk {
  count: number
  name: string
  isFocusedTopic: boolean
}

export interface ChannelsValue {
  channel: string
  posts: number
  flagged: number
}

export interface IDate {
  year: number
  month: number
  day: number
}
export interface IEducation {
  startDate: IDate
  endDate: IDate
  title: string
  grade: string
  school: string
  description: string
  schoolUrl: string
  fieldOfStudy: string
}

export interface ICareer {
  startDate: IDate
  endDate: IDate
  title: string
  company: string
  companyLogoUrl: string
  companyLinkedinURL: string
  description: string
  companyStaffCountRange: string
}

export interface ISkills {
  name: string
  passedSkillAssessment: boolean
  endorsementsCount: number
}

export interface IDigitalFootprints {
  url: string
  description: string
  userName: string
  platform: string
  image: string
  status: string
}

export interface IFollowUp {
  previousReportId: string
  sinceDate: string
}

export interface getSubjectBasicInformationResponse {
  message: string
  status: number
  info: getSubjectInfo
}
export interface getSubjectInfo {
  fullName: string
  followers: number
  following: number
  posts: number
  totalPosts: number
  postsCount: number
  score: number
  summary: summary | ISentimentAnalysisResponse
  sources: Source[]
  socialMedia: SocialMediaAccount[]
  profileImgUrl: string
  inputs: Inputs
  flaggedPosts: number
  positivePosts: number
  negativePosts: number
  webSearchPosts: number
  risks: Risk[]
  channelsValue: ChannelsValue[]
  pdf: string
  complianceSigned: string
  disclosureSigned: string
  summarySigned: string
  dynamicSigned: string
  otherAuthorizationSigned: string
  workEmails: string[]
  personalEmails: string[]
  phones: string[]
  address: string[]
  career: ICareer[]
  education: IEducation[]
  skills: ISkills[]
  digitalFootprints: IDigitalFootprints[]
  pwnedBreaches: IEmailBreach
  sentimentPercentages?: ISentimentPercentage[]
  reportType: EReportType
  anonymousPdf: string
  expandedPdf: string
  followUp: IFollowUp
  updatedAt: string
  useCase: string
  useCaseId: string
}

export enum EReportType {
  AiAnalyst = 'ai_analyst_report',
  Ai = 'ai_report',
  AdverseMedia = 'adverse_media_report',
  Assisted = 'assisted_report',
  FacialMatching = 'facial_matching',
}

export const enum EContentRadar {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}

export interface ISentimentAnalysisResponse {
  sentimentAnalysis: {
    overview: string
  }
  contentRadar: EContentRadar
  digitalPersonSnapshot: digitalPersonSnapshotTypes
  onlineBehavior: IOnlineBehavior[]
  redFlags: IRedFlag[]
  strengthsAndWeaknesses: {
    strengths: IStrengthWeakness[]
    weaknesses: IStrengthWeakness[]
  }
  personalityInsights: IPersonalityInsight[]
}

export interface digitalPersonSnapshotTypes {
  positiveAttributes: IPersonAttribute[]
  neutralAttributes: IPersonAttribute[]
  negativeAttributes: IPersonAttribute[]
}

export interface IPersonAttribute {
  trait: string
}

export interface IOnlineBehavior {
  behavior: string
}

export interface IRedFlag {
  flag: string
}

export interface IStrengthWeakness {
  description: string
}

export interface IPersonalityInsight {
  trait: string
}

export interface IEmailBreach {
  email: string
  breaches: IPwnedBreach[]
}

export interface ISentimentPercentage {
  sentiment: string
  percentage: number
}
export interface IPwnedBreach {
  Name: string
  Title: string
  Domain: string
  BreachDate: string
  AddedDate: string
  ModifiedDate: string
  PwnCount: number
  Description: string
  LogoPath: string
  DataClasses: string[]
  IsVerified: boolean
  IsFabricated: boolean
  IsSensitive: boolean
  IsRetired: boolean
  IsSpamList: boolean
  IsMalware: boolean
  IsSubscriptionFree: boolean
  IsStealerLog: boolean
}
export interface SocialMediaAccount {
  id: string
  name: string
  profileImgUrl: string
  userName: string
  profileLink: string
  bio?: string
  followers: number
  following: number
  postsCount: number
  totalPosts: number
  isPrivate: boolean
  isVerified: boolean
  flaggedCount: number
  scrapeStatus: string
  profileImgKey: string
}

export interface getSubjectBasicInformationRequest {
  id: string
}

export interface ISocialMediaPostResponse {
  name: string
  userName: string
  profileLink: string
  followers: number
  following: number
  postsCount: number
  totalPosts: number
  isPrivate: boolean
  posts: SocialMediaPostPaginated
  profileImgUrl: string
}

export interface SocialMediaPostPaginated {
  page: number
  size: number
  pages: number
  offset: number
  totalItems: number
  currentItems: number
  list: SocialMediaPost[]
}

export interface SocialMediaPost {
  type: string
  profileImgUrl: string
  link: string
  content: string
  date: string
  sentiment: number
  sentimentFlag: string
  flaged: boolean
  flagedText: string
  mediaUrl?: string
  videoUrl?: string
  flags: string[]
  sentimentReason: string
  flagReason: string
  platform: string
  translatedContent?: string
  language?: string
}

export type PlatformType =
  | 'LinkedIn'
  | 'Facebook'
  | 'Instagram'
  | 'Pinterest'
  | 'TikTok'
  | 'Twitter'
  | 'Reddit'
  | 'WebSearch'

export enum PlatformTypes {
  LINKEDIN = 'LinkedIn',
  FACEBOOK = 'Facebook',
  INSTAGRAM = 'Instagram',
  PINTEREST = 'Pinterest',
  TIKTOK = 'TikTok',
  TWITTER = 'Twitter',
  REDDIT = 'Reddit',
  WEBSEARCH = 'WebSearch',
}

export type FilterByType = 'Positive' | 'Negative' | 'Neutral' | 'Flagged'

export enum FilterByTypeEnum {
  POSITIVE = 'Positive',
  NEGATIVE = 'Negative',
  NEUTRAL = 'Neutral',
  FLAGGED = 'Flagged',
  TOPIC = 'Topic',
  WEBNEWS = 'Web/News',
}

export interface ISocialMediaPostRequest {
  id: string
  page: number
  pageSize: number
  plataform?: PlatformType
  filterBy?: FilterByType
  socialMediaId?: string
  flag?: string
}

export interface CancelReportRequest {
  id: string
}

export interface CancelReportResponse {
  message: string
  status: number
}

export interface GenarateAnonymousPdfResponse {
  info: {
    pdf: string
  }
}
export interface GenarateAnonymousPdfRequest {
  id: string
}

export interface GetSignedPdfUrlRequest {
  id: string
  type: string
}

export interface GetSignedPdfUrlResponse {
  message: string
  info: {
    url: string
  }
  status: number
}
